import { render, staticRenderFns } from "./AppReception.vue?vue&type=template&id=3168c616&scoped=true&"
import script from "./AppReception.vue?vue&type=script&lang=js&"
export * from "./AppReception.vue?vue&type=script&lang=js&"
import style0 from "./AppReception.vue?vue&type=style&index=0&id=3168c616&prod&lang=scss&scoped=true&"
import style1 from "./AppReception.vue?vue&type=style&index=1&id=3168c616&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168c616",
  null
  
)

export default component.exports